'use client';

import { memo } from 'react';

import Button from '@core/design-system/button';

import { useAuth } from '@core/features-core/auth/client';

import { IProps } from './model';
import { ButtonLoginContainer } from './styles';
import { UserAvatar } from '@mais-retorno-front/components/user-avatar';
import { LogIn } from 'lucide-react';

export const UserLoginButton = memo<IProps>(({ showMobile = false, id }) => {
  const { userIsLogged, userName, login } = useAuth();

  return (
    <ButtonLoginContainer showMobile={showMobile}>
      {userIsLogged ? (
        <div className="flex items-center">
          <UserAvatar />
          {userName && (
            <p className="min-w-[110px] w-[110px] mx-2 font-bold whitespace-nowrap overflow-hidden text-ellipsis">
              {userName}
            </p>
          )}
        </div>
      ) : (
        <Button
          id={id}
          sx={{
            textTransform: 'none',
            color: '#fff',
          }}
          fullWidth
          onClick={() => login()}
          startIcon={<LogIn size={14} />}
        >
          Acessar conta
        </Button>
      )}
    </ButtonLoginContainer>
  );
});
